import { render } from "./RegistrationIcons.vue?vue&type=template&id=6d02ac86&scoped=true"
const script = {}

import "./RegistrationIcons.vue?vue&type=style&index=0&id=6d02ac86&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d02ac86"]])

export default __exports__